import React from 'react'
import { Link } from 'react-router-dom';
import './Container.css';

function Container(props) {
    return (
        <>
      <li className='cards__item'>
        <Link className='cards__item__link' to={props.path}>
          <div className='cards__item__info'>
            <h5 className='cards__item__text__cont'>{props.text}</h5>
          </div>
        </Link>
      </li>
    </>
    )
}

export default Container
